import { View, Platform } from 'react-native'
import cn from '@ui/utils/cn'
import Button from '@ui/buttons/Button'
import { ButtonProps } from '@ui/buttons/Button/types'
import React from 'react'

type ButtonsProps = {
  buttons: ButtonProps[]
}

type ChildrenProps = {
  children: React.ReactNode
}

type Props = ButtonsProps | ChildrenProps

export const getClassName = (total: number, i: number, className?: string) => {
  return cn(
    'pointer-events-auto self-center',
    total === 2 && i === 0 && 'self-end',
    total === 2 && i === 1 && 'self-start',
    className
  )
}

export const ButtonsGridChildren = ({ children }: ChildrenProps) => {
  if (!children) return null
  const buttons = React.Children.toArray(children).filter((child) =>
    React.isValidElement(child)
  ) as Array<React.ReactElement<ButtonProps>>
  return (
    <>
      {buttons.map((button, i) => (
        <View
          key={i}
          className={cn(
            'relative inset-0',
            Platform.OS === 'web' && 'pointer-events-none',
            buttons.length < 3 && 'flex-1'
          )}
        >
          {React.cloneElement(button, {
            className: getClassName(
              buttons.length,
              i,
              cn(button.props.className, 'w-auto')
            ),
          })}
        </View>
      ))}
    </>
  )
}

export default function ButtonsGrid(props: Props) {
  if ('children' in props)
    return <ButtonsGridChildren>{props.children}</ButtonsGridChildren>
  const { buttons } = props
  if (!buttons || buttons.length === 0) return null
  return (
    <>
      {buttons?.map((button, i) => (
        <View
          key={i}
          className={cn(
            'relative inset-0',
            Platform.OS === 'web' && 'pointer-events-none',
            buttons.length < 3 && 'flex-1'
          )}
        >
          <Button
            key={`${i}`}
            size={Platform.select({ default: 'md', web: 'md' })}
            {...button}
            className={getClassName(buttons.length, i, button.className)}
          />
        </View>
      ))}
    </>
  )
}
